var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPContractualesBalken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #efb928;\n        stroke: #efb928;\n        stroke-width: .5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    transform: "translate(3.07, -0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7598",
    className: "cls-1",
    d: "M18.78.25H1.08c-.46,0-.82.37-.83.83v19.92H.25c0,.22.08.43.23.59l4.43,4.43c.16.15.37.24.59.24h13.29c.46,0,.82-.37.83-.83V1.08c0-.46-.37-.82-.83-.83ZM4.68,23.42l-1.59-1.59h1.59v1.59ZM17.95,24.59H6.34v-3.6c0-.46-.37-.82-.83-.83H1.91V1.91h16.04v22.68ZM15.46,7.44H4.4v-1.66h11.06v1.66ZM15.46,12.97H4.4v-1.66h11.06v1.66ZM9.93,18.5h-5.53v-1.66h5.53v1.66ZM11.31,20.44c0,1.37,1.11,2.49,2.49,2.49,1.37,0,2.49-1.11,2.49-2.49,0-1.37-1.11-2.49-2.49-2.49,0,0,0,0,0,0-1.37,0-2.49,1.12-2.49,2.49ZM14.63,20.44c0,.46-.37.83-.83.83s-.83-.37-.83-.83.37-.83.83-.83h0c.46,0,.82.37.83.83Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPContractualesBalken);
export default __webpack_public_path__ + "static/media/p-contractuales_BALKEN.be7608a600827924a8fdfda46bab91b7.svg";
export { ForwardRef as ReactComponent };